export const validateTransactionApi = {

    data:[
        {
            name:"Name",
            value:"Safayet"
        },
        {
            name:"Class",
            value:"Class 7"
        },
        {
            name:"Section",
            value:"Diamond 1"
        },
        {
            name:"Paid Amount",
            value:"25000"
        },
        {
            name:"Total Month",
            value:"25000"
        },
        {
            name:"Payment Type",
            value:"Cash"
        },
    ]
}